import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceSupportWebsitePagesRoute: InvariantJiraRoute = {
	name: 'csm-experience-support-website-pages',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/support-website/pages',
	exact: true,
};
